import { AssetIcon } from '@/components/icons';
import { fileTypeExcelIcon } from '@/assets/icons';
import { truncateAttachmentFilename } from '@/utils/truncateAttachmentFilename';

interface CsvAttachmentPreviewProps {
  file: File;
  onRemove: () => void;
}

export function CsvAttachmentPreview({ file, onRemove }: CsvAttachmentPreviewProps) {
  const displayName = truncateAttachmentFilename(file.name);

  return (
    <div className="chat-input__attachment" role="group" aria-label={`Attached file ${file.name}`}>
      <AssetIcon
        src={fileTypeExcelIcon}
        className="chat-input__attachment-icon"
        width={22}
        height={22}
      />
      <span className="chat-input__attachment-name" title={file.name}>
        {displayName}
      </span>
      <button
        type="button"
        className="chat-input__attachment-remove"
        aria-label={`Remove ${file.name}`}
        onClick={onRemove}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
          <path
            d="M2.5 2.5l7 7M9.5 2.5l-7 7"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
